(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["orska-header-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!window.orskaHeaderMegaBound) {
    window.orskaHeaderMegaBound = true;

    const normalizeLabel = (value) => (value || '').trim().toLowerCase();
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const attachMegaMenus = (root = document) => {
      const templates = Array.from(root.querySelectorAll('[data-orska-header-mega-template]'));

      templates.forEach((template) => {
        const nav = template.closest('.nav');
        const targetLabel = normalizeLabel(template.dataset.orskaHeaderMegaLabel);

        if (!nav || !targetLabel) return;

        nav.querySelectorAll('.nav-menu__item').forEach((item) => {
          const link = item.querySelector(':scope > a');
          const linkLabel = normalizeLabel(link?.textContent);

          if (!link || linkLabel !== targetLabel || item.querySelector(':scope > .nav-header-mega')) return;

          item.classList.add('nav-mega-item');
          link.setAttribute('aria-haspopup', 'true');
          link.setAttribute('aria-expanded', 'false');
          item.appendChild(template.content.cloneNode(true));
        });
      });
    };

    const finishAnimation = (row, panel, shouldStayOpen) => {
      row.classList.remove('is-opening', 'is-closing', 'is-animating');
      panel.style.height = '';

      if (!shouldStayOpen) {
        row.removeAttribute('open');
      }
    };

    const openRow = (row, panel) => {
      row.setAttribute('open', '');
      row.classList.add('is-opening', 'is-animating');
      panel.style.height = '0px';

      requestAnimationFrame(() => {
        panel.style.height = `${panel.scrollHeight}px`;
      });

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;

        panel.removeEventListener('transitionend', onTransitionEnd);
        finishAnimation(row, panel, true);
      };

      panel.addEventListener('transitionend', onTransitionEnd);
    };

    const closeRow = (row, panel) => {
      row.classList.add('is-closing', 'is-animating');
      panel.style.height = `${panel.scrollHeight}px`;

      requestAnimationFrame(() => {
        panel.style.height = '0px';
      });

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;

        panel.removeEventListener('transitionend', onTransitionEnd);
        finishAnimation(row, panel, false);
      };

      panel.addEventListener('transitionend', onTransitionEnd);
    };

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.nav-header-mega__summary');

      if (!summary) return;

      const row = summary.closest('.nav-header-mega__row');
      const panel = row?.querySelector('[data-nav-header-mega-panel]');

      if (!row || !panel) return;

      event.preventDefault();

      if (row.classList.contains('is-animating')) return;

      if (prefersReducedMotion()) {
        row.open = !row.open;
        return;
      }

      if (row.open) {
        closeRow(row, panel);
      } else {
        openRow(row, panel);
      }
    });

    attachMegaMenus();
    document.addEventListener('DOMContentLoaded', () => attachMegaMenus());
    document.addEventListener('shopify:section:load', (event) => attachMegaMenus(event.target));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["orska-ingredient-search-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-orska-search-chip]');
    if (!chip) return;

    const wrapper = chip.closest('.orska-ingredient-search-form');
    const form = wrapper?.querySelector('form');
    const input = form?.querySelector('input[name="q"]');
    if (!form || !input) return;

    input.value = chip.dataset.orskaSearchChip || chip.textContent.trim();
    form.requestSubmit();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["orska-product-accordion"] && !Shopify.designMode) return;
  try {
    if (!window.orskaProductAccordionBound) {
    window.orskaProductAccordionBound = true;

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const finishAnimation = (item, body, shouldStayOpen) => {
      item.classList.remove('is-opening', 'is-closing', 'is-animating');
      body.style.height = '';

      if (!shouldStayOpen) {
        item.removeAttribute('open');
      }
    };

    const openItem = (item, body) => {
      item.setAttribute('open', '');
      item.classList.add('is-opening', 'is-animating');
      body.style.height = '0px';

      requestAnimationFrame(() => {
        body.style.height = `${body.scrollHeight}px`;
      });

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;

        body.removeEventListener('transitionend', onTransitionEnd);
        finishAnimation(item, body, true);
      };

      body.addEventListener('transitionend', onTransitionEnd);
    };

    const closeItem = (item, body) => {
      item.classList.add('is-closing', 'is-animating');
      body.style.height = `${body.scrollHeight}px`;

      requestAnimationFrame(() => {
        body.style.height = '0px';
      });

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;

        body.removeEventListener('transitionend', onTransitionEnd);
        finishAnimation(item, body, false);
      };

      body.addEventListener('transitionend', onTransitionEnd);
    };

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.orska-product-accordion__head');

      if (!summary) return;

      const item = summary.closest('.orska-product-accordion');
      const body = item?.querySelector('.orska-product-accordion__body');

      if (!item || !body) return;

      event.preventDefault();

      if (item.classList.contains('is-animating')) return;

      if (prefersReducedMotion()) {
        item.open = !item.open;
        return;
      }

      if (item.open) {
        closeItem(item, body);
      } else {
        openItem(item, body);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
